import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

export const CAmenitiesSection = ({ id }) => {
  const [amenities, setAmenities] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAmenityIndex, setSelectedAmenityIndex] = useState(null); // Track index
  const charLimit = 100; // Character limit for the description

  const fetchData = async () => {
    try {
      const response = await corefetch(
        `Amenities/GetAmenitiesDetailsByDisplayedInID?displayedInID=${id}`
      );
      if (response && response.length > 0) {
        const mappedAmenities = response.map((amenity, index) => ({
          ...amenity,
          image: `${ImageURL}${amenity.imagePath}`,
          uniqueKey: `${amenity.amenitiesID}-${index}`, // Ensure unique keys
        }));
        setAmenities(mappedAmenities);
      }
    } catch (error) {
      setAmenities([]);
      console.error("Error fetching amenities:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (amenities?.length) {
      const $carousel = $(".amenities .owl-carousel");
      $carousel.owlCarousel({
        loop: true,
        margin: 30,
        mouseDrag: true,
        autoplay: true,
        dots: true,
        autoplayHoverPause: true,
        nav: false,
        responsiveClass: true,
        responsive: {
          0: { items: 1 },
          600: { items: 2 },
          1000: { items: 3 },
        },
      });

      // Attach click event manually to cloned and original items
      $carousel.on("click", ".item", function () {
        const index = $(this).index() % amenities.length;
        setSelectedAmenityIndex(index);
        setIsModalOpen(true);
      });
    }
  }, [amenities]);

  const openModal = (index) => {
    setSelectedAmenityIndex(index); // Set the index of the clicked item
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedAmenityIndex(null);
    setIsModalOpen(false);
  };

  if (!amenities || amenities.length === 0) {
    return null;
  }

  return (
    <>
      <section className="amenities section-padding">
        <div className="container">
          <div className="row mb-30">
            <div className="col-md-3">
              <div className="sub-title border-bot-light">Our Services</div>
            </div>
            <div className="col-md-9">
              <div className="section-title">Amenities</div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="service-slider owl-carousel owl-theme">
                {amenities.map((amenity, index) => (
                  <div
                    className="item"
                    key={amenity.uniqueKey}
                    style={{
                      height: "600px", // Fixed height for each item
                      overflow: "hidden", // Hide overflow content
                      marginBottom: "15px",
                    }}
                  >
                    <span className="number">{index + 1}</span>
                    <div
                      className="amenity-img"
                      onClick={() => openModal(index)} // Use index
                      style={{ cursor: "pointer", marginBottom: "15px" }}
                    >
                      <img
                        src={amenity.image}
                        alt={amenity.amenitiesType}
                        className="img-fluid"
                        style={{ objectFit: "cover" }}
                      />
                    </div>
                    <h5>
                      <a href="#" onClick={(e) => e.preventDefault()}>
                        {amenity.amenitiesType}
                      </a>
                    </h5>
                    <p
                      onClick={() => openModal(index)} // Use index
                      style={{ cursor: "pointer" }}
                    >
                      {amenity.description.length > charLimit
                        ? `${amenity.description.substring(0, charLimit)}...`
                        : amenity.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {isModalOpen && selectedAmenityIndex !== null && (
        <div id="ServiceModal" className="popup">
          <div
            className="modal-content"
            style={{
              maxHeight: "90vh",
              overflowY: "auto",
              padding: "20px",
              borderRadius: "8px",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-header">
              {amenities[selectedAmenityIndex].amenitiesType}
            </div>
            <div className="additional-text">
              <div className="row">
                <div className="col-5">
                  <img
                    src={amenities[selectedAmenityIndex].image}
                    alt={amenities[selectedAmenityIndex].amenitiesType}
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                      borderRadius: "8px",
                      maxWidth: "100%",
                    }}
                    className="odd"
                  />
                </div>
                <div className="col-7">
                  <p>{amenities[selectedAmenityIndex].description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
